import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RouterService } from 'src/app/services/router-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ReverseSiteInMaintenanceGuard implements CanActivate {

	constructor(private routerService:RouterService) {}

	canActivate() : boolean {
		if (environment.in_maintenance) {
			return true;
		} else {
			this.routerService.to404();
			return false;
		}
	}

}
